"use client"

import { useState, useCallback } from "react"
import { contactInfoService } from "@/services/api"
import type { ContactInfoResDTO, ContactInfoUpdateReqDTO } from "@/types/api"

export function useContactInfoOperations() {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const clearError = useCallback(() => {
    setError(null)
  }, [])

  const updateContactInfo = useCallback(async (data: ContactInfoUpdateReqDTO): Promise<ContactInfoResDTO | null> => {
    try {
      setLoading(true)
      setError(null)

      const result = await contactInfoService.updateContactInfo(data)
      return result
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Error al actualizar la información de contacto"
      setError(errorMessage)
      console.error("Error updating contact info:", err)
      return null
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    loading,
    error,
    updateContactInfo,
    clearError,
  }
}